import EWAViewer from "./EWAViewer";
import { useContext, useEffect, useState } from "react";
import { EwaContext } from "../../../context/EwaContext";
import './PersistentEwaViewer.scss';
import { useLocation } from "react-router-dom";
import Context from "../../../context";
import Spinner from "../Spinner";

const PersistentEwaViewer = () => {
  const { viewMode, isSafari } = useContext(Context);
  const {
    ewaDocs, setEwaDocs,
    isViewerVisible,
    lastDocIdRef,
    markDocAsNavigated,
    ewaOpenDocumentInfo, setEwaOpenDocumentInfo,
    ewaPaths,
    ewaOpenDocumentActive, setEwaOpenDocumentActive,
    isBuilderInitialised,
  } = useContext(EwaContext);
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ewaDocs.length && !ewaOpenDocumentActive && (viewMode === "mobile" || isSafari)) {
      if (ewaPaths.has(pathname) && lastDocIdRef.current && ewaDocs.length > 1) {
        setEwaDocs(prev => prev.filter(doc => doc.id === lastDocIdRef.current));
      } else if (!ewaPaths.has(pathname)) {
        setEwaDocs([]);
        lastDocIdRef.current = null;
      }
    }
  }, [isSafari, ewaDocs.length, ewaOpenDocumentActive, ewaPaths, lastDocIdRef, pathname, setEwaDocs, setEwaOpenDocumentInfo, viewMode])

  useEffect(() => {
    if (ewaOpenDocumentInfo?.ewaSourcePath === pathname && ewaOpenDocumentInfo?.updated) {
      setEwaOpenDocumentInfo(null);
      setEwaOpenDocumentActive(false);
    }
  }, [setEwaOpenDocumentActive, ewaOpenDocumentInfo?.ewaSourcePath, ewaOpenDocumentInfo?.updated, pathname, setEwaOpenDocumentInfo])

  if (!ewaDocs.length || !isBuilderInitialised) return null;

  return (
    <div
      className={`persistent-ewa-viewer ${isViewerVisible ? "visible" : "hidden"}`}
      aria-hidden={!isViewerVisible}
    >
      {ewaDocs.map((doc) => (
        <div
          key={doc.id}
          className={`ewa-viewer-wrapper ${doc.id === lastDocIdRef.current ? "active" : "inactive"} ${doc.fullscreen ? "fullscreen" : ""}`}
        >
          {loading && (
            <div className="ewa-loading-spinner">
              <Spinner type="small" />
            </div>
          )}
          <EWAViewer
            item={doc}
            mimeType="application/zip"
            markAsNavigated={() => markDocAsNavigated(doc.id)}
            setLoading={setLoading}
          />
        </div>
      ))}
    </div>
  );
};

export default PersistentEwaViewer;